module.exports = __webpack_public_path__ + "static/vivienda-d6ee1957bff9f607b9d6e52061297b1e.png";